
import { Profile } from "../../types";
import { DeleteContactButton } from "../../../DeleteContactButton";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { useState } from "react";

interface ContactActionsProps {
  profile: Profile;
}

export const ContactActions = ({ profile }: ContactActionsProps) => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleSendWelcomeEmail = async () => {
    try {
      setIsLoading(true);
      console.log('Sending welcome email directly for user:', profile.id);

      const { error: functionError } = await supabase.functions.invoke('send-welcome-email', {
        body: { 
          email: profile.email,
          firstName: profile.first_name,
          resetLink: `${window.location.origin}/auth?email=${encodeURIComponent(profile.email)}`,
          role: 'user'
        }
      });

      if (functionError) {
        console.error('Edge function error:', functionError);
        throw functionError;
      }

      console.log('Welcome email sent successfully');

      toast({
        title: "Success",
        description: "Welcome email sent successfully",
      });
    } catch (error) {
      console.error('Error sending welcome email:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: error instanceof Error ? error.message : "Failed to send welcome email",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="pt-4 flex justify-between items-center">
      <DeleteContactButton userId={profile.id} />
      <Button
        onClick={handleSendWelcomeEmail}
        className="ml-auto"
        variant="outline"
        disabled={isLoading}
      >
        <Mail className="mr-2 h-4 w-4" />
        {isLoading ? "Sending..." : "Send Welcome Email"}
      </Button>
    </div>
  );
};
